import {
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@libs/zapi-ui/shadcn";
import { UserIcon } from "@libs/zapi-ui/assets";
import { useNavigate } from "react-router-dom";
import { getRouteUserSettings, getRouteGlobalSettings } from "@/zapi-admin/shared/const/router";
import $api from "@/zapi-admin/shared/api/axios";
import { useAdminStore } from "@/zapi-admin/stores/admin-store";

export function UserMenu() {
  const navigate = useNavigate();
  const { user } = useAdminStore();
  const isSystemAdmin = user?.role === "systemAdmin";

  const handleLogout = async () => {
    try {
      await $api.post("/auth/logout");
      window.location.reload();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleUserSettings = () => {
    navigate(getRouteUserSettings());
  };

  const handleGlobalSettings = () => {
    navigate(getRouteGlobalSettings());
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Avatar className="h-8 w-8 cursor-pointer border border-zinc-300 flex justify-center">
          <AvatarFallback>
            <UserIcon className="text-zinc-500" />
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          variant="default"
          onClick={handleUserSettings}
          className="flex items-center gap-2 text-l text-gray-700 hover:bg-gray-100 cursor-pointer"
        >
          User Settings
        </DropdownMenuItem>
        {isSystemAdmin && (
          <DropdownMenuItem
            variant="default"
            onClick={handleGlobalSettings}
            className="flex items-center gap-2 text-l text-gray-700 hover:bg-gray-100 cursor-pointer"
          >
            Global Settings
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          variant="default"
          onClick={handleLogout}
          className="flex items-center gap-2 text-l text-gray-700 hover:bg-gray-100 cursor-pointer"
        >
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
